import { IsBoolean, IsDefined } from 'class-validator';

export class VisibilityStateDto {
  @IsDefined()
  @IsBoolean()
  desktop!: boolean;

  @IsDefined()
  @IsBoolean()
  tablet!: boolean;

  @IsDefined()
  @IsBoolean()
  mobile!: boolean;
}
